export function isNativeAdmin() {
  return /SophiaAdminNative\//.test(window.navigator.userAgent);
}
